import { render, staticRenderFns } from "./detailTrans.vue?vue&type=template&id=b119747c"
import script from "./detailTrans.vue?vue&type=script&lang=js"
export * from "./detailTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports